module.exports = __webpack_public_path__ + "img/orion_tr_24_12_10.dd8102ec.png";